import React, { } from "react";

import { Row, Col } from "react-bootstrap";

import { observer } from "mobx-react";


import { BottomsheetDropdown } from "../../../../../components";

const SimplyProtect = ({ form, data }) => {

  return (
   
      <div className="">
        <div className="mx-0 my-4">
          {/* <Col md={6} className="col-12">
            <div className="shadow p-3 bg-white rounded my-3"> */}
          {/* <div className="mb-2 text-description-text-color font-size-12 font-weight-light font-size-md-14">
                {form.$("policy-term").label}
              </div> */}
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey="label"
            bottomsheetTitle={form.$("policy-term").label}
            menuList={form.$("policy-term").extra.optionList}
            value={form.$("policy-term").value}
            onSelect={form.$("policy-term").onChange}
          />
          {/* </div>
          </Col> */}
        </div>
        <div className="mx-0 my-4">
          {/* <Col md={6} className="col-12">
            <div className="shadow p-3 bg-white rounded my-3"> */}
          {/* <div className="mb-2 text-description-text-color font-size-12 font-weight-light font-size-md-14">
                {form.$("premium-paying-term").label}
              </div> */}
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey="label"
            bottomsheetTitle={form.$("premium-paying-term").label}
            menuList={form.$("premium-paying-term").extra.optionList}
            value={form.$("premium-paying-term").value}
            onSelect={form.$("premium-paying-term").onChange}
          />
          {/* </div>
          </Col> */}
        </div>
      </div>
  
  );
};

export default observer(SimplyProtect);
